import { ApplicationInsights, SeverityLevel } from '@microsoft/applicationinsights-web';
import { runtimeConfig } from './RuntimeConfig';

export class TelemetryClientService {

  private static appInsights: ApplicationInsights;
  public static trackDetails: boolean;
  public static origin: string;

  public static initialize() {

    const connectionString = runtimeConfig.appInsightsConnectionString;
    if (!connectionString) {
      console.warn('Application Insights connection string is not set. Telemetry will not be sent.');
      return;
    }

    TelemetryClientService.appInsights = new ApplicationInsights({
      config: {
        connectionString,
        disableFetchTracking: false,
        enableCorsCorrelation: true,
        correlationHeaderExcludedDomains: ['js.hs-scripts.com', 'api.hubspot.com'],
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        loggingLevelConsole: 2,
        disableTelemetry: false
      }
    });

    TelemetryClientService.appInsights.loadAppInsights();

    const addBrowserRole = (envelope: any) => {
      envelope.tags['ai.cloud.role'] = 'BROWSER';
    };

    TelemetryClientService.appInsights.addTelemetryInitializer(addBrowserRole);
  }

  public static getProperties(data?: any) {

    const result = this.trackDetails ? { ...data } : {};

    if (TelemetryClientService.origin) {
      result.customer = TelemetryClientService.origin;
      result.refUri = TelemetryClientService.origin;
    }
    return result;
  }

  public static page(name: string, data?: any) {
    if (TelemetryClientService.appInsights) {
      TelemetryClientService.appInsights.trackPageView({ name, properties: TelemetryClientService.getProperties(data) });
    }
  }

  public static event(name: string, data?: any) {
    if (TelemetryClientService.appInsights) {
      TelemetryClientService.appInsights.trackEvent({ name, properties: TelemetryClientService.getProperties(data) });
    }
  }

  public static error(message: string, data?: any) {
    console.error(message, data || '');

    if (TelemetryClientService.appInsights) {
      // if pnpjs error
      if (data && 'isHttpRequestError' in data) {
        data.response.clone().text().then((text: string) => {
          TelemetryClientService.appInsights.trackException({ exception: new Error(message), severityLevel: SeverityLevel.Error, properties: this.getProperties({ ...data, text }) });
        }, () => {
          TelemetryClientService.appInsights.trackException({ exception: new Error(message), severityLevel: SeverityLevel.Error, properties: this.getProperties(data) });
        });
      } else {
        TelemetryClientService.appInsights.trackException({ exception: new Error(message), severityLevel: SeverityLevel.Error, properties: this.getProperties(data) });
      }
    }
  }

  public static warn(message: string, data?: any) {
    console.warn(message, data);
    if (TelemetryClientService.appInsights) {
      TelemetryClientService.appInsights.trackTrace({ message, severityLevel: SeverityLevel.Warning, properties: this.getProperties(data) });
    }
  }

  public static log(message: string, data?: any) {
    console.log(message, data);
    if (TelemetryClientService.appInsights && TelemetryClientService.trackDetails) {
      TelemetryClientService.appInsights.trackTrace({ message, severityLevel: SeverityLevel.Information, properties: this.getProperties(data) });
    }
  }

  public static debug(message: string, data?: any) {
    console.debug(message, data);
    if (TelemetryClientService.appInsights && TelemetryClientService.trackDetails) {
      TelemetryClientService.appInsights.trackTrace({ message, severityLevel: SeverityLevel.Verbose, properties: this.getProperties(data) });
    }
  }
}

